import { Params } from '@angular/router';
import { HisSessionStorageKeys } from '../../core/model/his-session-storage-keys';
import { HisSortCriteria } from './his-search-request';
import { SortMeta } from 'primeng/api';

export class HisSortOrder {
    key: string;
    value: string;
    order: number;
}

export class HisSearchResultColumnSortHelper {

    public static readonly SPEPERATOR = '_';
    public static sortCriteria: HisSortCriteria[] = [];
    private static safedSortCriteria: HisSortCriteria[] = [];

    /**
     * Sorts a HisSortOrder list of objects according to the attribute order.
     *
     * @param columnSortOrder Object list from type HisSortOrder.
     * @returns sorted columnSortOrder list.
     */
    private static sortColumSortOrder(columnSortOrder: HisSortOrder[]): HisSortOrder[] {
        columnSortOrder.sort((a, b) => {
            return a.order - b.order;
        });
        return columnSortOrder;
    }

    /**
     * Converts sortOrder value from -1 to 0 else to 1.
     *
     * @param sortOrder sortOrder
     * @returns converted sortOrder
     */
    static convert(sortOrder: number): number {
        return (sortOrder === -1) ? 0 : 1;
    }

    /**
     * Removes all session storage keys that are stored to load the sortorder
     */
    public static removeAllSessionStorageKeysContainingSortOrder() {
    	let sessionStorageObjekts = Object.keys(sessionStorage);
        //Loads all keys from the session storage and deletes those that were stored for loading the sortorder
        for (let key of sessionStorageObjekts) {
            if (key.startsWith(HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER)) {
                sessionStorage.removeItem(key);
            }
        }
    }

    /**
     * Filters out all session storage keys that have nothing to
     * do with the sorting and creates a sorted list, sorted by the column order.
     *
     * @returns an sorted list of session keys.
     */
    public static getSortedSortOrderKeyFromSessionStorage(): HisSortOrder[] {
    	let sessionStorageKeys = Object.keys(sessionStorage);

    	let columnSortOrder: HisSortOrder[] = [];

        for (let key of sessionStorageKeys) {
            if (key.startsWith(HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER)) {
               	let value = sessionStorage.getItem(key);

                let values = value.split(HisSearchResultColumnSortHelper.SPEPERATOR);

                let columnSort = new HisSortOrder();

                columnSort.key = key;
                columnSort.value = values[0];
                columnSort.order = Number(values[1]);
                columnSortOrder.push(columnSort);
            }
        }

    	return this.sortColumSortOrder(columnSortOrder);
    }

    /**
     * Creates a sortCriteria from a HisSortOrder object.
     *
     * @param columnSortedSortOrder HisSortOrder object to tranfer into sortCriteria.
     */
    public static createSortCriteriaBySessionStorageValues(columnSortedSortOrder: HisSortOrder[]) {
        this.sortCriteria = [];
    	for(let sortEntity of columnSortedSortOrder) {
            let startIndex = HisSessionStorageKeys.CS_SYS_SORT_LAST_COLUMN_SORTORDER.length + 1;
          	let endIndex = sortEntity.key.length;

            let colField = sortEntity.key.substring(startIndex, endIndex);

            let ascending: boolean = (sortEntity.value === '1');

            let sortCriterion = new HisSortCriteria(colField, ascending);
            console.log('his-search-result.component#createSortCriteriaBySessionSotorageValues(): #sortCriterion:', sortCriterion);

            this.sortCriteria.push(sortCriterion);
        }
    }

    /**
     * Saving a sortCriteria in a variable for later reading out.
     *
     * @param sortCriteria sortCritia to store in variable.
     */
    public static setSafedSortCriteria(sortCriteria: HisSortCriteria[]) {
        HisSearchResultColumnSortHelper.safedSortCriteria = sortCriteria || [];
    }

    /**
     * Loads stored sortCriteria from variable sortCriteriaToLoadInTableFilter for later readout.
     *
     *@returns stored sortCriteria
     */
    public static getSafedSortCriteria(): HisSortCriteria[] {
        return HisSearchResultColumnSortHelper.safedSortCriteria;
    }

    /**
     * Parses query params into SortMeta[].
     * Expects indexed pairs: sortField0/sortOrder0, sortField1/sortOrder1, …
     *
     * @param queryParams - Angular route query parameters.
     * @returns Ordered array of SortMeta, empty if none present.
     */
    public static createMultiSortMetaFromQueryParams( queryParams: Params ): SortMeta[] {
        const multiSortMeta: SortMeta[] = [];
        let index = 0;

        while ( queryParams[`sortField${index}`] ) {
            multiSortMeta.push( {
                field: queryParams[`sortField${index}`],
                order: Number( queryParams[`sortOrder${index}`] ) === -1 ? -1 : 1
            } );

            index++;
        }

        return multiSortMeta;
    }

    /**
     * Encodes SortMeta[] as sortFieldN/sortOrderN keys into a copy of queryParams.
     * Does not mutate the original — returns a new Params object.
     * Existing sortField* sortOrder* keys are set to undefined( router drops them from URL ).
     *
     * @param queryParams - Base query parameters.
     * @param multiSortMeta - Sort state to encode, index 0 = primary sort.
     * @returns New Params object with updated sort keys.
     */
    public static addMultiSortMetaToQueryParams( queryParams: Params, multiSortMeta: SortMeta[] ): Params {
        const updatedParams = { ...queryParams };

        Object.keys( updatedParams )
            .filter( key =>
                key.startsWith( 'sortField' ) ||
                key.startsWith( 'sortOrder' ) )
            .forEach( key => updatedParams[key] = undefined );

        multiSortMeta.forEach( ( sortMeta, index ) => {
            updatedParams[`sortField${index}`] = sortMeta.field;
            updatedParams[`sortOrder${index}`] = sortMeta.order.toString();
        } );

        return updatedParams;
    }
}
